module.exports = __webpack_public_path__ + "img/top.34a30797.jpg";